import { render } from "./TopNav.vue?vue&type=template&id=433c9971"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"
script.render = render

export default script